(function() {
  var RETURN_PAGE = '/pages/ai-customize';

  var currentPath = window.location.pathname;

  if (currentPath.indexOf(RETURN_PAGE) === 0) {
    document.addEventListener('click', function(e) {
      var target = e.target;
      while (target && target !== document) {
        if (target.tagName === 'BUTTON' || target.tagName === 'A') {
          var text = (target.textContent || target.innerText || '').trim().toLowerCase();
          if (text === 'log in' || text === 'login' || text === 'sign in') {
            e.preventDefault();
            e.stopPropagation();
            var loginUrl = '/customer_authentication/login?return_to=' + encodeURIComponent(RETURN_PAGE);
            window.location.href = loginUrl;
            return;
          }
        }
        target = target.parentElement;
      }
    }, true);
  }
})();